module.exports = __webpack_public_path__ + "static/media/galerija_2017 (23).208ad2f0.jpg";